import { CLEAR_EMPLOYEES_LEAVES } from "../../../enums/Employees/employees.types";

export const clearEmployeesLeavesAction = () => {
    return {
        type: CLEAR_EMPLOYEES_LEAVES,
    };
};